import { Component, OnInit, Inject, ChangeDetectionStrategy } from '@angular/core';
import { LinkService } from '../../../services/link.service';

@Component({
  selector: 'app-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class LinkComponent implements OnInit {
  public links:any[];

  constructor(private linkService: LinkService) {

  }

  ngOnInit() {
    this.linkService.get().subscribe(res=>{
      this.links = res;
    })
  }

}
